import './ContentBuilderTemplate.scss';

import React from 'react';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cnContentBuilderTemplate } from './index';
import { Typography } from '@dataartdev/uikit/Typography';
import { Article } from '../../Article/Article';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { ValuesCard } from '../../ValuesCard/ValuesCard';
import { IRoot2 } from './models/CTI_2.props';

export const ContentBuilderTemplate: React.FC<IRoot2> = props => {
  const {
    type,
    withoutColors,
    title,
    text,
    items,
    columnsCount,
    pageId,
    contentId,
  } = usePropsHandler(cnContentBuilderTemplate(), props);

  const typeNumber = type?.toString();

  interface ColumnConfiguration {
    [key: number]: {
      mobileCol: number;
      tabletCol: number;
      desktopCol: number;
    };
  }

  const columnConfigurations: ColumnConfiguration = {
    2: { mobileCol: 12, tabletCol: 6, desktopCol: 6 },
    3: { mobileCol: 12, tabletCol: 6, desktopCol: 4 },
    4: { mobileCol: 12, tabletCol: 6, desktopCol: 3 },
  };

  const safeColumnsCount = columnsCount || '4';
  const { mobileCol, tabletCol, desktopCol } = columnConfigurations[
    +safeColumnsCount
  ];

  const sizeMap: Record<string, string> = {
    '5137': 'm',
    '30134': 'sm',
  };

  const size = pageId != null && sizeMap[pageId] ? sizeMap[pageId] : 's';

  return (
    <div
      id={contentId}
      className={cnContentBuilderTemplate({
        type: typeNumber ? typeNumber : '2',
        gray: withoutColors || false,
      })}
    >
      <Grid
        breakpoints={{
          desktop: { cols: 12 },
          tablet: { cols: 12 },
          mobile: { cols: 12 },
        }}
      >
        <GridItem
          breakpoints={{
            desktop: { col: 8 },
            tablet: { col: 12 },
            mobile: { col: 12 },
          }}
        >
          {!withoutColors && title && (
            <Typography.Title size="lg" as="h2" parse>
              {title}
            </Typography.Title>
          )}
          {withoutColors && title && (
            <Typography.Title size="lg" as="h2" parse>
              {title}
            </Typography.Title>
          )}
          {text && <Article content={text} />}
        </GridItem>
      </Grid>

      {items && items.length > 0 && !withoutColors && (
        <Grid
          breakpoints={{
            desktop: { cols: 12, gap: 'xl' },
            tablet: { cols: 12, gap: 'm' },
            mobile: { cols: 12, gap: 'm' },
          }}
        >
          {!withoutColors &&
            items.map(item => (
              <GridItem
                key={item.id}
                breakpoints={{
                  desktop: { col: desktopCol },
                  tablet: { col: tabletCol },
                  mobile: { col: mobileCol },
                }}
              >
                <ValuesCard
                  {...item}
                  size={size}
                  picture={item?.backgroundImage || item?.picture}
                />
              </GridItem>
            ))}
        </Grid>
      )}

      {items && items?.length > 0 && withoutColors && (
        <Grid
          breakpoints={{
            desktop: { cols: 10, gap: 'xl' },
            tablet: { cols: 8, gap: 'm' },
            mobile: { gap: 'm' },
          }}
        >
          {withoutColors &&
            items.map(item => (
              <GridItem
                key={item.id}
                breakpoints={{ desktop: { col: 2 }, tablet: { col: 4 } }}
              >
                <div className={cnContentBuilderTemplate('Item')}>
                  <img src={item.picture?.url} alt={item.title} />
                  <Typography.Title size="tiny" as="h3" parse>
                    {item.title}
                  </Typography.Title>
                </div>
              </GridItem>
            ))}
        </Grid>
      )}
    </div>
  );
};

export default ContentBuilderTemplate;
